import { IInteriorOrganizerItemsResponse } from '../interior-organizer-interfaces';


export const getFilteredItems = (
    storageItemData: IInteriorOrganizerItemsResponse,
    filterWidth: number,
    filterHeight: number,
    filterDepth: number,
    filterName: string,
) => {
    let item = storageItemData?.items || [];

    item = item.filter(item => {

        const itemWidth = item.width || 0;
        const itemHeight = item.height || 0;
        const itemDepth = item.depth || 0;

        const isItemWidthMatch = itemWidth >= filterWidth;
        const isItemHeightMatch = itemHeight >= filterHeight;
        const isItemDepthMatch = itemDepth >= filterDepth;
        const isItemNameMatch = filterName.trim() === '' || item.name.toLowerCase().includes(filterName.trim().toLowerCase());

        return isItemWidthMatch &&
            isItemHeightMatch &&
            isItemDepthMatch &&
            isItemNameMatch;
    });

    return item;
};

export const formatStorageItems = (storageItemsData: IInteriorOrganizerItemsResponse|null) : IInteriorOrganizerItemsResponse|null => {
    if(!storageItemsData) return null;

    const items = storageItemsData?.items || [];
    const attachments = storageItemsData?.attachments || [];

    for(const item of items) {
        item.attachments = attachments.filter(attachment => attachment.storage_item_id === item.id) || [];
    }

    storageItemsData.items = items;

    return storageItemsData;
};